import { css } from "@linaria/core";

import { units } from "@ui/css";
import { colors, typographies } from "@ui/kit";
import { makeSelectors } from "@utils/css";

export const skipLink = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200000;

  padding-inline: ${units.px(20)};

  height: ${units.px(60)};

  background: ${colors.bg()};
  border-bottom: ${units.px(2)} solid ${colors.gray.sim40()};
  border-right: ${units.px(2)} solid ${colors.gray.sim40()};
  border-bottom-right-radius: ${units.px(4)};

  display: flex;
  align-items: center;

  font-family: ${typographies.body()};
  color: ${colors.text.primary()};

  outline: none;
  pointer-events: none;

  opacity: 0;
  transition: opacity 0.1s linear;

  &:focus-visible {
    pointer-events: auto;
    opacity: 1;
  }
`;

export const skipLinkSelectors = makeSelectors({
  anchor: skipLink,
});
